import { Text, Link, LoadingIndicator } from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { useGetArenaQuery } from "~/graphql/mainHooks";
import { toGlobalId } from "~/utils/graphql-helpers";
import { generateGpMainUrl } from "~/utils/url";
import { quickLinkAnchor } from "./styles_vanilla.css";

interface WorkspaceLinkProps {
  arenaId: number | null;
}

export const WorkspaceLink = ({ arenaId }: WorkspaceLinkProps) => {
  const isValidArenaId = typeof arenaId === "number";
  const objectId = isValidArenaId ? String(arenaId) : null;

  const { data: arenaData, loading } = useGetArenaQuery({
    context: withClientContext("staff"),
    variables: { id: toGlobalId("ArenaObjectType", objectId || "") },
    skip: !objectId,
  });

  if (!isValidArenaId) {
    return null;
  }

  const secondLevelDomain = arenaData?.arena?.secondLevelDomain;

  if (loading) {
    return (
      <>
        <Text>Workspace</Text>
        <LoadingIndicator variant="primary" size="small" />
      </>
    );
  }

  if (!secondLevelDomain) {
    return null;
  }

  const gpMainUrl = generateGpMainUrl(secondLevelDomain);

  return (
    <>
      <Text>Workspace</Text>
      <Link
        href={`${gpMainUrl}/dashboard`}
        className={quickLinkAnchor}
        variant="primary"
        icon="external-link"
        shouldOpenInNewTab={true}
        iconPosition={"right"}
      >
        View
      </Link>
    </>
  );
};
